import { RadioBoolean, RadioBooleanProps, Typography as FoodsTypography } from "@foodpilot/foods";
import { Box, Typography as MuiTypography } from "@mui/material";
import { t } from "i18next";
import type { ComponentAppearance } from "src/components/appearance";

type RadioBooleanField = RadioBooleanProps & {
    title?: string;
    description?: string;
    required?: boolean;
    appearance?: ComponentAppearance;
};
export const RadioBooleanField = (props: RadioBooleanField) => {
    const { title, description, required, appearance = "legacy", ...radioProps } = props;
    const isProductUxV2 = appearance === "product-v2";
    const requiredText = required ? "*" : "";
    return (
        <Box
            sx={(theme) => ({
                display: "flex",
                flexDirection: "column",
                gap: theme.spacing(1.25),
            })}
        >
            {title &&
                (isProductUxV2 ?
                    <FoodsTypography variant="body-semibold">{`${title}${requiredText}`}</FoodsTypography>
                :   <MuiTypography variant="body-semibold">{`${title}${requiredText}`}</MuiTypography>)}
            {description &&
                (isProductUxV2 ?
                    <FoodsTypography variant="body">{description}</FoodsTypography>
                :   <MuiTypography variant="body">{description}</MuiTypography>)}
            <RadioBoolean {...radioProps} trueKeyName={t("common.yes", "Yes")} falseKeyName={t("common.no", "No")} />
        </Box>
    );
};
